import { useCurrentCast } from '@/modules/casts/compositions'
import { computed, Ref } from '@vue/composition-api'

const useCastInScene = (sceneId: Ref<string|null|undefined>) => {
  const { currentCast } = useCurrentCast()
  const sceneCastId = computed(() => currentCast.value?.getSceneCastId(sceneId.value ?? '') ?? null)
  const sceneCastStreamId = computed(() => currentCast.value?.getCastSourceStreamId(sceneCastId.value ?? '') ?? '')
  const isCastStreamActive = computed(() => {
    const sceneCastStream = currentCast.value?.source_streams[sceneCastStreamId.value] ?? null
    return !!sceneCastStream && sceneCastStream.active
  })

  return {
    isCastStreamActive,
    sceneCastId,
    sceneCastStreamId
  }
}

export default useCastInScene
